import { useState } from 'react';
import { applyOffsetFilter } from '../../state/patternActions';
import type { DocumentMeta } from '../../core/types';
import { Checkbox, Modal, NumberInput } from '../components/controls';

/**
 * Filter - Other - Offset. Half the canvas with wrapping on is the standard way
 * to bring a tile's seams into the middle, where they can be painted out.
 */
export function OffsetDialog({
  doc,
  open,
  onClose,
}: {
  doc: DocumentMeta;
  open: boolean;
  onClose: () => void;
}) {
  const [dx, setDx] = useState(Math.round(doc.width / 2));
  const [dy, setDy] = useState(Math.round(doc.height / 2));
  const [wrap, setWrap] = useState(true);

  const apply = () => {
    applyOffsetFilter(dx, dy, wrap);
    onClose();
  };

  return (
    <Modal
      open={open}
      title="Offset"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="button" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="button button--primary" onClick={apply}>
            Apply
          </button>
        </>
      }
    >
      <div className="field">
        <span className="field__label" style={{ width: 76 }}>
          Horizontal
        </span>
        <NumberInput value={dx} min={-doc.width} max={doc.width} onChange={setDx} />
        <span className="field__suffix">px right</span>
      </div>
      <div className="field">
        <span className="field__label" style={{ width: 76 }}>
          Vertical
        </span>
        <NumberInput value={dy} min={-doc.height} max={doc.height} onChange={setDy} />
        <span className="field__suffix">px down</span>
      </div>
      <Checkbox label="Wrap around" checked={wrap} onChange={setWrap} />
    </Modal>
  );
}
